var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPhoneIconRed(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "49px",
    height: "49px",
    viewBox: "0 0 49 49",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Group 7") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Page-1",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Medium-Copy-6",
    transform: "translate(-60, -407)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-7",
    transform: "translate(60, 407)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    fill: "#FFE1E3",
    cx: 24.5,
    cy: 24.5,
    r: 24.5
  }), /*#__PURE__*/React.createElement("g", {
    id: "noun-phone-1147912",
    transform: "translate(24, 24.5) rotate(10) translate(-24, -24.5)translate(12, 14)",
    fill: "#8B131C",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group",
    transform: "translate(0, 0)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M21.6642611,15.6340791 L17.0635202,13.5786629 C16.4173487,13.2882236 15.6160961,13.444614 15.1766995,13.9361265 L13.4966537,15.8128109 C11.8424547,15.0532006 10.6018055,14.3159317 9.15438136,13.0648088 C7.60356982,11.72432 6.77647033,10.6295875 5.94937085,9.24441567 L8.09466014,7.79221945 C8.66329104,7.41241428 8.84421905,6.71982839 8.50820989,6.16129138 L6.13029886,2.20684935 C5.71674911,1.51426346 4.68287476,1.29084866 3.93331584,1.71533678 L1.01262078,3.41328929 C0.340602445,3.81543594 -0.0471004401,4.48568035 0.00459327784,5.17826624 C0.0562869958,5.89319361 0.159674432,6.80919431 0.366449304,7.43475576 C1.21939565,10.2721238 3.26129751,13.1988577 6.15614572,15.678762 C9.02514707,18.1586663 12.4110856,19.9236433 15.6936367,20.6832536 C16.4173487,20.839644 17.47707,20.9290099 18.3300163,20.9960343 C19.1571158,21.0407173 19.9583684,20.7055951 20.397765,20.1023751 L22.3104326,17.5331049 C22.7239823,16.8628605 22.4396669,15.9915427 21.6642611,15.6340791 Z",
    id: "Path"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.1055765,7.79258871 C14.5777225,7.92145364 15.0498685,8.1791835 15.4147086,8.56577829 C15.8010098,8.95237307 16.058544,9.40340033 16.1873111,9.87590507 C16.294617,10.2624999 16.6594571,10.5202297 17.0672196,10.4987522 L17.1530643,10.4987522 C17.711055,10.4772747 18.1188175,9.94033753 17.9685892,9.40340033 C17.7539774,8.63021075 17.3462149,7.87849866 16.7238406,7.27712899 C16.1014664,6.65428184 15.3717862,6.24620956 14.5991837,6.03143468 C14.0626541,5.88109226 13.5261246,6.28916454 13.5046634,6.84757923 L13.5046634,6.93348918 C13.461741,7.32008397 13.7192752,7.68520127 14.1055765,7.79258871 Z",
    id: "Path"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.9055965,4.84601846 C14.3286768,5.0617804 15.7000086,5.62276144 16.7867244,6.52896158 C17.8993145,7.45673792 18.5720433,8.5787 18.804911,9.76539066 C18.9084077,10.1969145 19.3741431,10.5205574 19.917501,10.4989813 L19.9951235,10.4989813 C20.6419782,10.4774051 21.1077135,9.9811526 20.9783426,9.46332395 C20.6419782,7.90983799 19.7622559,6.42108061 18.3391756,5.21281376 C16.8902212,4.0045469 15.1307765,3.27095631 13.2419609,3.01204198 C12.6209805,2.92573721 12.0258742,3.3141087 12,3.83193735 L12,3.89666593 C12,4.3713422 12.3881128,4.75971369 12.9055965,4.84601846 Z",
    id: "Path"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.9918861,9.46069257 C23.6202709,7.14604548 22.4311021,4.91792725 20.3996054,3.14408555 C18.3681086,1.37024385 15.8163506,0.331897495 13.1654951,0.00741425759 C12.5709107,-0.0574823899 12.025875,0.310265279 12.0011007,0.851070674 L12.0011007,0.937599538 C11.9763263,1.41350829 12.3727159,1.80288817 12.8929773,1.86778482 C15.0978944,2.12737141 17.2037142,3.01429226 18.88837,4.48528293 C20.5730258,5.95627361 21.5639998,7.81664417 21.8860664,9.72027916 C21.9603894,10.1745557 22.4063277,10.5206711 22.9513634,10.4990389 L23.0504608,10.4990389 C23.6202709,10.4557745 24.0662092,9.97986575 23.9918861,9.46069257 Z",
    id: "Path"
  }))))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPhoneIconRed);
export default __webpack_public_path__ + "static/media/phone-icon--red.2a82e0a9fc431f35109289e7c0eb8d2b.svg";
export { ForwardRef as ReactComponent };